<template>
  <v-navigation-drawer v-model="drawer" app clipped>
    <v-list dense subheader class="pt-8" nav>
      <template v-for="(item, $i) in items">
        <v-list-item
          :input-value="$route.path === item.path"
          color="primary"
          v-if="!item.children && !item.subheader"
          :key="$i"
          @click="() => item.path !== $route.path && $router.push(item.path)"
        >
          <v-list-item-icon>
            <v-icon small v-if="item.icon">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
        <template v-else-if="item.subheader">
          <v-divider :key="'divider' + $i"></v-divider>
          <v-subheader :key="$i">{{
            item.subheader.toUpperCase()
          }}</v-subheader>
        </template>

        <v-list-group v-else :value="$route.path === item.path" :key="$i">
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon small v-if="item.icon">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </template>

          <v-list-item
            v-for="child in item.children"
            :key="child.title"
            :input-value="$route.path === item.path + child.path"
            color="primary"
            @click="
              () =>
                item.path + child.path !== $route.path &&
                $router.push(item.path + child.path)
            "
          >
            <v-list-item-icon></v-list-item-icon>
            <v-list-item-title>{{ child.title }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { sync, get } from 'vuex-pathify'

export default {
  name: 'AppNavigationDrawer',

  computed: {
    drawer: sync('app/drawer'),
    owner: get('app/owner'),

    items() {
      return [
        {
          icon: 'mdi-briefcase-search',
          title: 'Förfrågningar',
          path: `/${this.owner}/inquiries`,
        },
        {
          icon: 'mdi-briefcase',
          title: 'Upphittade föremål',
          path: `/${this.owner}/lost-properties`,
        },
        {
          subheader: 'business intelligence',
        },
        {
          icon: 'mdi-chart-bar',
          title: 'Upphittade, förfrågningar och utlämnat',
          path: `/${this.owner}/business-intelligence/found-inquiries-resolved`,
        },
        {
          subheader: 'adminsitration',
        },
        {
          icon: 'mdi-database',
          title: 'Stamdata',
          path: `/${this.owner}/masterdata`,
          children: [
            {
              title: 'Kategorier',
              path: '/categories',
            },
            {
              title: 'Underkategorier',
              path: '/subcategories',
            },
            {
              title: 'Email mallar',
              path: '/email-templates',
            },
          ],
        },
      ]
    },
  },
}
</script>
